import type { TokenData } from "./types/chat.types";

const cookieName = "chatbot_session_id";

export const getLongLivedTokenObject = async (): Promise<TokenData> => {
  const LONG_LIVED_TOKEN = import.meta.env.VITE_LONG_LIVED_TOKEN || "";
  if (!LONG_LIVED_TOKEN) {
    console.log("Long lived token expected but not provided");
  }
  const tokenData: TokenData = {
    publicAccessToken: LONG_LIVED_TOKEN,
    tokenExpires: "",
    isAnonymous: true,
    scopes: [],
  };
  return tokenData;
};

export const getSessionIdCookie = (): string => {
  const cookiesString = document.cookie;
  const cookiesArray = cookiesString.split(";");

  for (const cookie of cookiesArray) {
    const trimmedCookie = cookie.trim();
    if (trimmedCookie.startsWith(`${cookieName}=`)) {
      return trimmedCookie.substring(`${cookieName}=`.length);
    }
  }

  return "";
};

export const setSessionIdCookie = (sessionId: string, maxAgeMinutes: number): string => {
  const maxAge = maxAgeMinutes * 60;

  const cookieString = `${cookieName}=${sessionId}; Path=/; Secure; SameSite=None; Max-Age=${maxAge}`;

  document.cookie = cookieString;

  return cookieString;
};

export const removeSessionIdCookie = (): void => {
  document.cookie = `${cookieName}=; Path=/; Secure; SameSite=None ; Max-Age=0`;
};